export default (state, action) => {
  switch (action.type) {
    case "ADD_TO_BAG":
      return {
        ...state,
        bagItems: [...state.bagItems, action.payload],
      }
    case "REMOVE_FROM_BAG":
      return {
        ...state,
        bagItems: state.bagItems.filter(
          bagItem => bagItem.id !== action.payload
        ),
      }
    default:
      return state
  }
}
